export default "__VITE_ASSET__CRd9acou__"